export const AUTH = 'READ_AUTH';
export const BROWSERTEST = 'READ_BROWSERTEST';
export const CALL = 'READ_CALL';
export const MCPTEST = 'READ_MCPTEST';
export const DOWNTIME = 'READ_DOWNTIME';
export const ENVIRONMENT = 'READ_ENVIRONMENT';
export const FILE = 'READ_FILE';
export const JUDGE = 'READ_JUDGE';
export const REPORT = 'READ_REPORT';
export const SCHEDULE = 'READ_SCHEDULE';
export const SUBSCRIPTION = 'READ_SUBSCRIPTION';
export const TOKEN = 'READ_TOKEN';
export const USER = 'READ_USER';
export const WORKFLOW = 'READ_WORKFLOW';
